import { styled, TextField } from '@mui/material';

export const WhiteTextField = styled(TextField)((_theme) => ({
  '& .MuiInputBase-root': {
    color: '#000',
  },
  '& .MuiInputBase-root fieldset': {
    borderColor: '#000',
  },
  '& .MuiInputBase-root.Mui-focused fieldset': {
    borderColor: '#000',
  },
  '& .MuiFormLabel-root': {
    color: '#000',
  },
  '& .MuiFormLabel-root.Mui-focused': {
    color: '#000',
  },
  '& .MuiSvgIcon-root': {
    color: '#000',
  },
  '& .MuiFormHelperText-root': {
    color: '#000',
  },
}));
